import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './Style.css';
import ModalTrigger from '../../../shared/modal/ModalTrigger';
import { convertScaleValues, convertTextValues } from '../../../shared/util/assessments';

function StressDialSlider(props) {
  const { t } = useTranslation();
  const [textValue, setTextValue] = useState('');
  const [rotation, setRotation] = useState(0);
  const [rangeValue, setRangeValue] = useState('');

  const converValueToRotation = (value) => {
    const scaleValue = convertScaleValues(value.toString());
    if (scaleValue === 5) {
      return 0;
    }
    let newRotation = -100 + (180 / 10) * scaleValue;
    if (newRotation >= 360) {
      newRotation = -360;
    }
    return newRotation;
  };

  useEffect(() => {
    if (props.assessmentValues[props.questionid]) {
      const text = convertTextValues(
        props.assessmentValues[props.questionid].toString(),
        props.textValue
      );
      setTextValue(text);
      const newRotation = converValueToRotation(props.assessmentValues[props.questionid]);
      setRotation(newRotation);
      setRangeValue(props.assessmentValues[props.questionid].toString());
    } else {
      setRotation(0);
      setTextValue(props.textValue[2]);
      setRangeValue('3');
      props.onSetValue({ id: props.questionid, value: '3' });
    }
  }, []);

  const onSlide = (event) => {
    const { value } = event.target;
    const scaleValue = convertScaleValues(value);
    if (scaleValue === 5) {
      setRotation(0);
    } else {
      const degree = -100 + (180 / 10) * scaleValue;
      let newRotation = degree;
      if (newRotation >= 360) {
        newRotation = -360;
      }
      setRotation(newRotation);
    }

    setRangeValue(value);
    setTextValue(convertTextValues(value, props.textValue));
    props.onSetValue({ id: props.questionid, value: value.toString() });
  };

  return (
    <div className={`req question_block${props.width}`}>
      <fieldset id={props.questionid} data-input-type="stress-dial-slider">
        <legend className="assessment_question_title">{props.questionTitle}</legend>
        {props.modalText && (
          <ModalTrigger
            modalText={props.modalText}
            onOpenModal={props.onOpenModal}
            question={props.questionid}
            questionTitle={props.questionTitle}
          />
        )}
        <div className="answer_block fs-exclude">
          <div>
            <div
              className={`dialSlider ${props.width}`}
              id={`${props.questionid}-stress-slider-container`}
            >
              <div className="dial">
                <div className="needle" style={{ transform: `rotate(${rotation}deg)` }} />
              </div>
              <div className={`range-container scale-5 value-${rangeValue}`}>
                <input
                  type="range"
                  min="1"
                  max="5"
                  value={rangeValue}
                  onChange={onSlide}
                  id={`${props.questionid}_slider`}
                  aria-valuetext={textValue}
                  aria-label={`${props.questionTitle} ${t('slider.description.from')} ${props.textValue[0]} ${t('slider.description.to')} ${props.textValue[4]}`}
                  data-uw-ignore-s3
                />
              </div>
              <label
                htmlFor={`${props.questionid}_slider`}
                className="valueHandle"
                id={`${props.questionid}_value_handle`}
              >
                {textValue}
              </label>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  );
}

export default StressDialSlider;
